import { render, staticRenderFns } from "./CreateEditMerchant.vue?vue&type=template&id=a84757a6&scoped=true"
import script from "./CreateEditMerchant.vue?vue&type=script&lang=js"
export * from "./CreateEditMerchant.vue?vue&type=script&lang=js"
import style0 from "./CreateEditMerchant.vue?vue&type=style&index=0&id=a84757a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84757a6",
  null
  
)

export default component.exports